import React from 'react'
import BadgeBox from "../../../../styles/img/knw-badge.png";
import { UiCol } from "../grid-container/GridContainer"


export default function BadgesBox(props) {

    return (
        <>
            <UiCol>
                <div className='sb-badges-box'>
                    <div className='sb-badges-box__icon'>
                        <img src={BadgeBox} />
                    </div>
                    <h5 className='mt-3'>{props.badgeName}</h5>
                </div>
            </UiCol>

        </>
    )
}
